module.exports = __webpack_public_path__ + "img/customer06.5edc84f.png";